import React from 'react'
import { Legacy_CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler';
import { Props_SnippetImageAndText } from './ImageAndText.props'

export const SnippetImageAndText = (props: Props_SnippetImageAndText) => {
    const reversed = props.image?.position?.value === 'left';
    const themeClass = props.theme?.theme?.value === "blog" ? " snippet-image-and-text--theme-blog" : "";

    return (
        <section className={`snippet-image-and-text ${reversed ? 'snippet-image-and-text--reversed' : ''}${themeClass}`}>
            <div className="snippet-image-and-text__container">
                <div className="snippet-image-and-text__content">
                    <h2 className="snippet-image-and-text__title">{props.heading?.heading?.value}</h2>
                    <div className="snippet-image-and-text__text">
                    { Legacy_CompileMarkdown(props.markdown?.markdown?.value || '') }
                    </div>
                </div>
                <figure className="snippet-image-and-text__image-container">
                    <img className="snippet-image-and-text__image"
                     src={props.image?.src?.value}
                      alt={props.image?.alt?.value}
                      loading='lazy'
                       />
                </figure>
            </div>
        </section>
    );
};